import React from "react";
import { Link } from "react-router-dom";
import BrandMark from "./BrandMark";
import Newsletter from "./Newsletter";
import SocialLinks from "./SocialLinks";
import SocialStrip from "./SocialStrip";
import { footerLinks, legacyLinks, business } from "../data/business";
import { useSite } from "../hooks/useSite";

export default function SiteFooter() {
  const { paused, setPaused, reduced } = useSite();
  return (
    <>
      <SocialStrip />
      <footer className="ro-footer">
        <div className="ro-container">
          <div className="ro-footer__grid">
            <nav className="ro-footer__links" aria-label="Footer navigation">
              {footerLinks.map((l) => (
                <Link key={l.to} to={l.to}>
                  {l.label}
                </Link>
              ))}
            </nav>
            <div className="ro-footer__right">
              <Newsletter />
              <div className="ro-footer__brand">
                <BrandMark id="footer" light />
              </div>
            </div>
          </div>
          <div className="ro-footer__bottom">
            <SocialLinks light />
            <nav className="ro-footer__legacy" aria-label="More from RollOver">
              {legacyLinks.map((l) => (
                <Link key={l.to} to={l.to}>
                  {l.label}
                </Link>
              ))}
            </nav>
          </div>
          <div className="ro-footer__meta">
            <span>
              {business.legalName}
            </span>
            {reduced ? (
              <span className="ro-footer__motion" role="status">
                Animations off (system reduced-motion setting)
              </span>
            ) : (
              <button type="button" className="ro-footer__motion" aria-pressed={paused} onClick={() => setPaused(!paused)}>
                {paused ? "Resume animations" : "Pause animations"}
              </button>
            )}
          </div>
        </div>
      </footer>
    </>
  );
}
